import { JobRating } from "../../common/JobOrder";
import { baseApi } from "./base";

export type MMCCourse = {
  id: number;
  courseName: string;
  location: "ONBOARD" | "ASHORE" | "NTH";
  root: "MMC" | "Other" | "TRAINING";
  required: boolean;
  blockNa: boolean;
};

export type MMCRequirement = {
  id: number;
  vesselId: number | undefined;
  fleetId: number | undefined;
  rating: JobRating;
  courseList: MMCCourse[];
};

export const mmcApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMMCRequirement: builder.query<
      MMCRequirement,
      { vessel: number; rating: JobRating }
    >({
      query: ({ vessel, rating }) => ({
        method: "GET",
        url: `MMC?vessel=${vessel}&rating=${rating}`,
      }),
    }),
  }),
});

export const { useGetMMCRequirementQuery } = mmcApi;
